import { render, staticRenderFns } from "./good_detail.vue?vue&type=template&id=6d879ebe&scoped=true"
import script from "./good_detail.vue?vue&type=script&lang=js"
export * from "./good_detail.vue?vue&type=script&lang=js"
import style0 from "./good_detail.vue?vue&type=style&index=0&id=6d879ebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d879ebe",
  null
  
)

export default component.exports